// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Cost,
} from './';

export default {
  path: 'cost',
  name: 'Cost',
  childRoutes: [
    { path: 'cost', name: 'Cost', component: Cost, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/cost/route.js